import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBoxVertical/Types";
import { useCustomerModel } from "../baseCustomerModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IVRMCustomerDetail } from "../baseCustomerService";
import { getFormValidatorErrText } from "@/utils/utils"
import { DetailType } from "@/types/ScmEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { debounce } from "lodash";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YHDetailNav } from "@/components/YHDetailNav";

export const BaseCustomerDetails = () => {
    const {
        addFormVal,
        editFormVal,
        lookFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertCustomer,
        editCustomer,
        getCustomerOne,
        setAddFormVal,
        setSelectedRowKeys,
        saveLoading, setSaveLoading
    } = useCustomerModel();
    const { getTreeSelectOne } = useDictModel();

    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, parentInfo } = detailsInfo

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && mode === "edit") {
            getCustomerOne(id, mode)
        }
        mode === "look" && getCustomerOne(id, mode)
    }, [detailsInfo]);

    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-5-1-1");
            let editNavExist = findNav("13-5-1-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        // let { parentInfo } = detailsInfo
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "13-5-1");
            detailsInfo.mode === "edit" ? updateEditFormVal(null) : updateAddFormVal(null);
        }
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailsInfo.mode === "edit") {
                editCustomer({ ...res, id: detailsInfo.id } as IVRMCustomerDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertCustomer(res as IVRMCustomerDetail).then(res => {
                    setSelectedRowKeys([res as string])
                    res && onClose()
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户编码",
                fieldName: "code",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入客户名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "传真号码",
                fieldName: "fax"
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "客户类型",
                fieldName: "categoryCode",
                treeData: getTreeSelectOne(DictCodeEnmu.CUSTOMER_TYPE),
                rules: [{ required: true, message: "请选择客户类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电子邮箱",
                fieldName: "email"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "办公地址",
                fieldName: "address",
                rules: [{ required: true, message: "请输入客户联系地址" }]
            },
            //  {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "登记日期",
            //     fieldName: "createTime",
            //     disable: true
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "办公电话",
                fieldName: "tel",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "邮编",
                fieldName: "postCode",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "公里数",
                fieldName: "mileage"
            },
        ]
    };
    const priceFormItem: IYhFormItemsBox = {
        title: "开票信息",
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票抬头",
                fieldName: "invoiceTitle"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "营业执照",
                fieldName: "licenseNo"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开户银行",
                fieldName: "bank"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "银行账户",
                fieldName: "bankAcct"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "邮寄地址",
                fieldName: "postAddress"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "公司法人",
                fieldName: "corporation"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "经营范围",
                fieldName: "businessScope"
            }
        ]
    }

    const otherFormItem: IYhFormItemsBox = {
        title: "其它信息",
        // disabled: true,
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "客户状态",
                fieldName: "enable"
            }
        ]
    }
    const typeForm = {
        add: addFormVal,
        edit: editFormVal,
        look: lookFormVal
    }
    const typeTitle = {
        add: "新增",
        edit: "编辑",
        look: "查看",
    }
    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        disabled: mode === DetailType.look,
        labelAlign: "right",
        // formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem, priceFormItem, otherFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getCustomerOne(detailsInfo.id, mode)
        }
        message.success("重置成功")
    }
    const action = <>
        {mode != "look" &&
            <YhAuth resCode={ResourceAuthEnum.DATA_C_C_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { onSubmit() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        }
        {mode != "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => reset()}
        >重置</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onClose}
        >取消</Button>
    </>;

    return (
        <>
            {/* <YhPageHeader title="客户详情" /> */}
            {/* <YhBox title={`客户${typeTitle[mode]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox> */}
            <YHDetailNav
                title={`客户${typeTitle[mode]}`}
                btns={action}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}